<div class="options">
  <button
    *ngFor="let option of menuOptions"
    type="button"
    (click)="onSelect(option)"
    trackable="Edit delivery/Instructions/{{ option.title }}">
    <div>
      <ng-container *ngComponentOutlet="option.iconComponent; inputs: { color: brandColor }"></ng-container>
      <span class="title">{{ option.title }}</span>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
      <path d="M1 9L5 5L1 1" stroke="#BBC6D6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</div>

<common-edit-order-contact-us-button
  [brandColor]="brandColor"
  [trackableText]="'instructions'"
  [style.bottom]="'2.4rem'"></common-edit-order-contact-us-button>
